var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('mpx-image',{staticClass:"icon",attrs:{"src":(_vm.trainIconUrl)}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }